import { Link } from 'react-router-dom';
import { Section, SectionHeading } from '../layout/Section.jsx';

/**
 * The houses the store carries, as a wall of square tiles.
 *
 * Every tile is the same cream ground, so the wall reads as one set and the
 * logos do the distinguishing. A brand with no logo uploaded yet — a normal
 * state on a fresh catalogue — still gets a face: its initial, in gold.
 */
export const HomeBrands = ({ brands }) => {
  if (!brands?.length) return null;

  return (
    <Section className="border-t border-mist">
      <SectionHeading eyebrow="Who makes it" title="The houses we stock" action={{ label: 'All brands', to: '/brands' }} />
      <ul className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {brands.slice(0, 12).map((brand) => (
          <li key={brand._id}>
            <Link
              to={`/brand/${brand.slug}`}
              className="group flex h-full flex-col border border-mist bg-surface transition-colors hover:border-brand focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
            >
              <span className="block aspect-square overflow-hidden bg-cream p-4">
                {brand.logo ? (
                  <img
                    src={brand.logo}
                    alt=""
                    loading="lazy"
                    decoding="async"
                    width="240"
                    height="240"
                    className="size-full object-contain transition-transform duration-500 group-hover:scale-105"
                  />
                ) : (
                  <span aria-hidden="true" className="grid size-full place-items-center font-display text-3xl text-brand">
                    {(brand.name ?? '?').trim().charAt(0).toUpperCase()}
                  </span>
                )}
              </span>
              <span className="flex flex-1 flex-col items-center px-3 py-3 text-center">
                <span className="w-full truncate text-2xs font-semibold tracking-[0.08em] text-ink uppercase group-hover:text-brand">
                  {brand.name}
                </span>
                {brand.productCount > 0 && (
                  <span className="mt-0.5 text-[11px] text-muted tabular-nums">
                    {brand.productCount} {brand.productCount === 1 ? 'product' : 'products'}
                  </span>
                )}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </Section>
  );
};

export default HomeBrands;
